module.exports = __webpack_public_path__ + "img/back.f4eaa28d.svg";